// Wealthsimple Cash CSV. Mirrors load_wealthsimple_cash_csv.
//
// Headers: Date, Description, Transaction Type, Amount, Balance. Amount
// is signed (negative = outflow → expense, positive = inflow → income).
// Flip to project convention.

import {
  type Transaction,
  newTransaction,
  makeId,
  parseAmount,
  parseDate,
  normalizeVendor,
  isInterPortalTransfer,
} from "../common.js";
import { parseCsv, toDictRows, findHeaderIndex } from "../csv.js";

export async function loadWealthsimpleCash(
  text: string,
  filename: string,
): Promise<Transaction[]> {
  const rows = parseCsv(text);
  const headerIdx = findHeaderIndex(rows, ["Date", "Description"]);
  if (headerIdx < 0 || headerIdx >= rows.length - 1) return [];
  const dicts = toDictRows(rows[headerIdx], rows.slice(headerIdx + 1));

  const out: Transaction[] = [];
  for (const row of dicts) {
    const date = parseDate(row["Date"] || "");
    if (!date) continue;
    const amount = -parseAmount(row["Amount"] || "0");
    if (amount === 0) continue;
    const description = (row["Description"] || row["Transaction Type"] || "Wealthsimple Cash")
      .trim()
      .replace(/^"|"$/g, "");
    if (isInterPortalTransfer(description)) continue;

    const id = await makeId("wealthsimple_cash", "Wealthsimple Cash", date, amount, description);
    out.push(
      newTransaction({
        id,
        date,
        vendor_raw: description,
        vendor_key: normalizeVendor(description) || "wealthsimple",
        amount: Math.round(amount * 100) / 100,
        portal: "wealthsimple_cash",
        account: "Wealthsimple Cash",
        account_kind: "debit",
        source_file: filename,
        raw: row,
      }),
    );
  }
  return out;
}
